import { render } from "./TheHeaderNavigationList.vue?vue&type=template&id=b91e5cf8"
import script from "./TheHeaderNavigationList.vue?vue&type=script&lang=js"
export * from "./TheHeaderNavigationList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__